/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_F_Url1Inputs */

const vi_sitesettings_f_url1 = /** @type {(inputs: Sitesettings_F_Url1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ (URL)`)
};

/**

* @param {Sitesettings_F_Url1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_f_url1 = /** @type {((inputs?: Sitesettings_F_Url1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_F_Url1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_f_url1(inputs)
});
export { sitesettings_f_url1 as "siteSettings_f_url" }